import React from "react";
import { Flex, Select } from "../../../resourses/digitallabs/one-x-ui";

const DynamicSelectCountry = ({
  field,
  value,
  isMain,
  fieldRefs,
  normalizeCountryOptions,
  normalizeSelectValue,
  updateValue,
  renderLabelWithPrefix,
  fieldIsRequired,
  validateSingleField,
  validateVisible,
  setErrors,
  setIsValid,
  onFormValidityChange,
  submitted,
  errors,
  countries_metaData,
}) => {
  const items = normalizeCountryOptions(countries_metaData);
  const current = value ?? field.default_answer ?? "";
  const fieldName = field?.name;

  return (
    <Flex key={fieldName} direction="column" gap="xs" className="dfh-field-wrapper" ref={(el) => (fieldRefs.current[fieldName] = el)}>
      <Select
        items={items}
        value={normalizeSelectValue(current)}
        closeOnSelect
        searchable
        label={{
          label: renderLabelWithPrefix(isMain, field.question),
          optional: !fieldIsRequired(field),
        }}
        valuePlaceholder="Select Country"
        onValueChange={(details) => {
          const selectedValue = details.value?.[0] ?? "";
          updateValue(fieldName, selectedValue);
        }}
        onBlur={() => {
          const single = validateSingleField(field);
          setErrors((prev) => ({ ...prev, ...single }));

          const validation = validateVisible();
          const valid = Object.keys(validation).length === 0;

          setIsValid(valid);
          if (typeof onFormValidityChange === "function") {
            onFormValidityChange(valid);
          }
        }}
        size="md"
        helperText={submitted && errors[fieldName] ? { message: errors[fieldName], status: "error" } : undefined}
      />
    </Flex>
  );
};

export default DynamicSelectCountry;
